<template>
  <div
    id="login"
    class="d-flex flex-column align-items-center wrapper_auth_required"
  >
    <div v-if="step !== 2" class="image_wrapper text-center">
      <img :src="ClipFinancialReport" />
    </div>
    <div class="text_wrapper text-center">
      <h2 class="text_title">{{ $t('modals.authRequired.title') }}</h2>
      <h3 class="text_body">{{ $t('modals.authRequired.body') }}</h3>
    </div>
    <div class="form_wrapper">
      <AuthStep2 v-if="step === 2" />
      <AuthStep1 v-else />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { makeEvent } from '@/helpers/base/amplitude'
import ClipFinancialReport from '@/assets/illustrations/ClipFinancialReport.svg'
import AuthStep1 from '@/components/auth/AuthStep1.vue'
import AuthStep2 from '@/components/auth/AuthStep2.vue'

// Страница входа для гостя на /id/:id: данные отдаются только авторизованным.
// Форма прямо на странице, без попапа. Шаг 2 — виджет Telegram для web-версии.
export default {
  name: 'AuthRequired',
  components: {
    AuthStep1,
    AuthStep2,
  },
  data() {
    return {
      ClipFinancialReport,
    }
  },
  computed: {
    ...mapState('authModule', {
      step: state => state.step,
    }),
  },
  mounted() {
    makeEvent('auth required page')
  },
}
</script>

<style scoped>
.wrapper_auth_required {
  background: var(--bg-surface);
  width: 100%;
  padding: 0 20px 60px;
  margin: 100px 0 0;
}
@media (max-width: 992px) {
  .wrapper_auth_required {
    margin: 30px 0 0;
  }
}
.image_wrapper img {
  width: 220px;
  max-width: 70vw;
}
.text_wrapper,
.image_wrapper {
  margin-bottom: 35px;
}
.text_title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px;
}
.text_body {
  font-size: 16px;
  font-weight: 400;
  margin: 0;
  max-width: 420px;
}
.form_wrapper {
  width: 100%;
  max-width: 350px;
}
</style>
